module.exports = __webpack_public_path__ + "static/media/FavoriteBlack.6450dd5f.svg";